import React from 'react'
import { makeStyles } from '@cicero/ui'
import { ContentCommands } from 'editor/commands'
import { IElementDefinition, IRenderElementProps } from '../EditorService'
import { ElementBlock } from './ParagraphElement'

export const BulletListElement = ({ children, attributes }: IRenderElementProps<any>) => {
  const { list } = useStyles()
  return <ElementBlock attributes={attributes}>
    <ul className={list}>{ children }</ul>
  </ElementBlock>
}

export const NumberedListElement = ({ children, attributes }: IRenderElementProps<any>) => {
  const { list } = useStyles()
  return <ElementBlock attributes={attributes}>
    <ol className={list}>{ children }</ol>
  </ElementBlock>
}

export const ListItemElement = ({ children, attributes }: IRenderElementProps<any>) => {
  const { listItem } = useStyles()
  return <li {...attributes} className={listItem}>{children}</li>
}

export const BulletListElementDef: IElementDefinition = {
  renderer(props) { return <BulletListElement {...props} /> },
}

export const NumberedListElementDef: IElementDefinition = {
  renderer(props) { return <NumberedListElement {...props} /> },
}

export const ListItemElementDef: IElementDefinition = {
  commands: [
    { title: 'List Enter', shortcut: 'enter', handler: (e, s) => ContentCommands.enterOnList(s) },
    // { title: 'List Tab', shortcut: 'tab', handler: (e, s) => ContentCommands.tabOnList(s) },
    // { title: 'List Reverse Tab', shortcut: 'shift+tab', handler: (e, s) => ContentCommands.tabOnList(s, true) },
  ],
  renderer(props) { return <ListItemElement {...props} /> },
}

const useStyles = makeStyles({
  list: {
    margin: 0,
  },
  listItem: {
    margin: '6px 0',
  },
})
